import { tr } from "./language";
import axios from "axios";

export const MAX_IMAGE_BYTES = 20 * 1024 * 1024;
const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
const uploads = new Map();
// Confirmed keys belong to the current seller; discard cached uploads when the account changes.
if (typeof window !== "undefined") {
  window.addEventListener("voocly:auth", () => uploads.clear());
  window.addEventListener("storage", () => uploads.clear());
}

/** Upload composed high-resolution masters directly; product/shop JSON carries only confirmed keys. */
export async function uploadSellerImage(source, purpose) {
  if (typeof source !== "string" || !source.startsWith("data:")) return source;
  const match = /^data:(image\/(?:jpeg|png|webp));base64,([A-Za-z0-9+/=\r\n]+)$/.exec(source);
  if (!match) throw new Error(tr("Use a JPEG, PNG, or WebP image."));
  const bytes = Uint8Array.from(atob(match[2]), char => char.charCodeAt(0));
  if (bytes.byteLength === 0 || bytes.byteLength > MAX_IMAGE_BYTES) throw new Error(tr("Images must be 20 MB or smaller."));
  let cacheKey;
  if (globalThis.crypto?.subtle) {
    const hash = new Uint8Array(await crypto.subtle.digest("SHA-256", bytes));
    cacheKey = `${purpose}:${Array.from(hash, byte => byte.toString(16).padStart(2, "0")).join("")}`;
    if (uploads.has(cacheKey)) return uploads.get(cacheKey);
  }
  const upload = async () => {
    const { data } = await axios.post(`${API}/images/uploads`, {
      file_name: `master.${match[1] === "image/png" ? "png" : match[1] === "image/webp" ? "webp" : "jpg"}`,
      mime_type: match[1], file_size_bytes: bytes.byteLength, purpose,
    });
    const response = await fetch(data.upload_url, {
      method: "PUT", credentials: "omit", headers: { "Content-Type": match[1] }, body: bytes,
    });
    if (!response.ok) throw new Error(tr("Image upload failed."));
    const confirmed = await axios.post(`${API}/images/uploads/confirm`, { key: data.key });
    return confirmed.data.key;
  };
  const pending = upload();
  if (cacheKey) {
    if (uploads.size >= 30) uploads.delete(uploads.keys().next().value);
    uploads.set(cacheKey, pending);
  }
  try { return await pending; }
  catch (error) { if (cacheKey) uploads.delete(cacheKey); throw error; }
}
